import style from "./style.module.scss";
import classnames from "classnames";
import React from "react";
import useJnjBranding from "@jmc/utils/hooks/useJnjBranding";

export type Sizes = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
type Spacings = 0 | 4 | 8 | 16 | 24 | 32;

interface PropTypes {
    container?: boolean;
    item?: boolean;
    width?: string;
    gap?: Spacings;
    children: React.ReactNode;
    cols?: Sizes;
    rows?: Sizes;
    size?: string;
    overview?: boolean;
}

export const CSSGrid = ({
    container = false,
    item = true,
    width = "0",
    gap = 16,
    children,
    cols = 1,
    rows = 1,
    size = "auto",
    overview = false,
    ...other
}: PropTypes): JSX.Element => {
    const { jnjFullBranded } = useJnjBranding();

    const classname = classnames(
        style.element,
        container ? style.container : null,
        item ? style.item : null,
        cols > 1 ? style[`cols-${String(cols)}`] : null,
        rows > 1 ? style[`rows-${String(rows)}`] : null,
        container ? style[`gap-${String(gap)}`] : null,
        overview ? style["grid-overview"] : null,
    );

    return jnjFullBranded ? (
        <div {...other} className={classnames(classname)}>
            {children}
        </div>
    ) : (
        <div
            {...other}
            className={classname}
            style={{
                gridTemplateColumns: size === "auto" ? `repeat(auto-fill, minmax(${width}, 1fr)) ` : "unset",
            }}
        >
            {children}
        </div>
    );
};
